import * as React from "react";
import ReportsDataGridDataGridPanel from "./reportDataGrid";

export interface whenWasIPaidReviewProps {
    sessionId: string;
}

const whenWasIPaidReview: React.FC<whenWasIPaidReviewProps> = (props) => {
    const sessionId = props.sessionId;

    return (
        <ReportsDataGridDataGridPanel sessionId={sessionId} />
    );
};

export default whenWasIPaidReview;
